import type { SupportedCoinDto } from '@coin-depo-types';

export interface SortableCoin {
  balance: number;
  balance_currency: number;
  order: number;
  interest_currency: number;
}

export const sortInstruction = {
  coins: (coins: SupportedCoinDto[], order: boolean): SupportedCoinDto[] =>
    coins.sort((a: SupportedCoinDto, b: SupportedCoinDto) =>
      order ? -coinsWithoutOrder(a, b) : coinsWithoutOrder(a, b)
    ),
  balance: (coins: SupportedCoinDto[], order: boolean) =>
    coins.sort((a: SupportedCoinDto, b: SupportedCoinDto) =>
      order
        ? currencyBalanceWithoutOrder(a, b)
        : -currencyBalanceWithoutOrder(a, b)
    ),
  interestPaid: (coins: SupportedCoinDto[], order: boolean) =>
    coins.sort((a: SupportedCoinDto, b: SupportedCoinDto) =>
      order
        ? currencyInterestWithoutOrder(a, b)
        : -currencyInterestWithoutOrder(a, b)
    ),
};

const coinsWithoutOrder = (a: SupportedCoinDto, b: SupportedCoinDto) => {
  return Number(a.order) >= Number(b.order) ? 1 : -1;
};

const currencyBalanceWithoutOrder = (
  a: SupportedCoinDto,
  b: SupportedCoinDto
) => {
  if (Number(a.balance?.balance) && Number(b.balance?.balance)) {
    return Number(a.balance?.balance_currency) > Number(b.balance?.balance_currency) ? -1 : 1;
  } else if (Number(a.balance?.balance)) {
    return -1;
  } else if (Number(b.balance?.balance)) {
    return 1;
  } else {
    return Number(a.order) >= Number(b.order) ? 1 : -1;
  }
};

const currencyInterestWithoutOrder = (
  a: SupportedCoinDto,
  b: SupportedCoinDto
) => {
  if (Number(a.balance?.interest_currency) && Number(b.balance?.interest_currency)) {
    return Number(a.balance?.interest_currency) > Number(b.balance?.interest_currency) ? -1 : 1;
  } else if (Number(a.balance?.interest_currency)) {
    return -1;
  } else if (Number(b.balance?.interest_currency)) {
    return 1;
  } else {
    return Number(a.order) >= Number(b.order) ? 1 : -1;
  }
};
